import React from 'react';
import ReactHtmlParser from 'react-html-parser';

import { retrieveContent } from '../../utils/content-fragments';

/**
 * Component used to retrieve claims from a content fragment.
 * @param styles must use the parent's styles to make it look right
 * @param pathToClaim url path to claim (do not include domain)
 * @param placeholderClaim text to use if content fragment can't be retrieved
 * @returns {*}
 */
export default ({ styles, pathToClaim }) => {
    const [claims, setClaims] = React.useState('');
    React.useEffect(() => {
        const getClaims = async () => {
            const content = await retrieveContent(pathToClaim);
            setClaims(content);
        };
        getClaims();
    }, []);

    return (
        <React.Fragment>
            {ReactHtmlParser(claims)}
            <style jsx>{styles}</style>
        </React.Fragment>
    );
};
